import { Mark } from '@tiptap/core';

/** API 保存形式 {{red}}…{{/red}} に対応する赤色マーク（青・黒と同時には付かない） */
export const BulletinRed = Mark.create({
  name: 'bulletinRed',
  excludes: 'bulletinBlue bulletinBlack',
  parseHTML() {
    return [{ tag: 'span[data-bulletin-red]' }];
  },
  renderHTML() {
    return ['span', { 'data-bulletin-red': '', style: 'color:#d32f2f;font-weight:inherit;' }, 0];
  },
});

/** API 保存形式 {{blue}}…{{/blue}} に対応する青色マーク（赤・黒と同時には付かない） */
export const BulletinBlue = Mark.create({
  name: 'bulletinBlue',
  excludes: 'bulletinRed bulletinBlack',
  parseHTML() {
    return [{ tag: 'span[data-bulletin-blue]' }];
  },
  renderHTML() {
    return ['span', { 'data-bulletin-blue': '', style: 'color:#0288d1;font-weight:inherit;' }, 0];
  },
});

/** API 保存形式 {{black}}…{{/black}} — 本文色を黒（通常）に戻す（赤・青と同時には付かない） */
export const BulletinBlack = Mark.create({
  name: 'bulletinBlack',
  excludes: 'bulletinRed bulletinBlue',
  parseHTML() {
    return [{ tag: 'span[data-bulletin-black]' }];
  },
  renderHTML() {
    return ['span', { 'data-bulletin-black': '', style: 'color:inherit;font-weight:inherit;' }, 0];
  },
});
